'use es6';

import http from 'conversations-http/clients/http';
export const hardDeleteMessagesInThread = ({
  threadId
}) => {
  const url = `conversations-threads/v1/message/${threadId}/purge`;
  return http.delete(url);
};